<template>
  <ws-chip v-if="absence.backup1_until" v-model="backupUntil" :is-disabled="isDisabled"></ws-chip>
</template>
<script>
import WsChip from '@/modules/customerVbzWorksheet/components/WsChip.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'Backup1Until',
  mixins: [wsMixin],
  components: { WsChip },

  props: {
    absence: Object,
    isDisabled: { type: Boolean, default: false },
  },
  computed: {
    backupUntil() {
      return this.mx_backup1Until(this.absence);
    },
  },
};
</script>
